import { SUCCESS_GETTING_TOKENS } from '../constants/index'

const initialState = {};

export default (state = initialState, action) => {
  switch(action.type){
    case SUCCESS_GETTING_TOKENS:
      const tokenType = action.tokenType || '*';

      return Object.assign({}, state, {
        [tokenType]: action.payload.tokens
      });

    default:
      return state;
  }
};